export default {"src":"/_next/static/media/cxr5.c594685a.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};